const getApiBaseUrl = () => {
  // If environment variable is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on environment
  if (process.env.NODE_ENV === 'development') {
    return 'https://localhost:7210'; // Development - call local backend
  }
  
  return 'https://interview-r.com'; // Production - call custom domain
};

export const API_CONFIG = {
  baseURL: getApiBaseUrl(),
  endpoints: {
    auth: {
      register: '/api/auth/register',
      login: '/api/auth/login',
      google: '/api/auth/google',
      logout: '/api/auth/logout',
    },
    profile: {
      get: '/api/profile',
      update: '/api/profile/update',
      uploadPicture: '/api/profile/picture',
    },
      timeSlots: {
    my: '/api/TimeSlot/Interviewer',
    addBatch: '/api/TimeSlot/add-batch',
    delete: '/api/TimeSlot',
    available: '/api/TimeSlot/available',
    },
    interviewers: {
      list: '/api/interviewer',
      filter: '/api/interviewer/filter',
      availableSlots: '/api/interviewer/slots',
      getById: '/api/interviewer/:id',
      availableLanguages: '/api/interviewer/available-languages',
      availableSpecialties: '/api/interviewer', // Will extract from interviewer list
    },
    bookings: {
      create: '/api/booking/create',
      createPaymentIntent: '/api/booking/create-payment-intent',
      list: '/api/booking',
      listForInterviewer: '/api/booking/Interviewer',
      listForInterviewee: '/api/booking/interviewee',
      cancel: '/api/booking/cancel',
      accept: '/api/booking/:id/accept',
      decline: '/api/booking/:id/decline',
      getById: '/api/booking/:id',
      addMeetingLink: '/api/booking/meeting-link',
    },
    reviews: {
      create: '/api/reviews/create',
      listForInterviewer: '/api/reviews/interviewer/:id',
    },
  },
  headers: {
    'Content-Type': 'application/json',
  },
}; 